import { alpha, styled, TextField, Theme, Typography } from '@material-ui/core';

export const ClusterTitleWrapper = styled('div')({
  background: alpha('#DD906A', 0.1),
  padding: '1.5rem',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '15px 15px 0px 0px',
});

export const StyledIndex = styled(Typography)({
  fontWeight: 600,
  color: '#6C2604',
  textWrap: 'nowrap',
  lineHeight: 1.5,
});

export const ClusterTitleContainer = styled(Typography)<Theme, { ishoverenabled?: boolean }>(
  ({ ishoverenabled }) => ({
    color: '#6C2604',
    height: '100%',
    width: '100%',
    minWidth: 'auto',
    lineHeight: 1.5,
    minHeight: '1.5em',
    ...(ishoverenabled && {
      '&:hover': {
        cursor: 'pointer',
        background: '#F5E3D9',
      },
    }),
  })
);

export const ClusterTitleTextField = styled(TextField)({
  color: '#6C2604',
  width: '100%',
  background: '#F5E3D9',
  '& input': {
    padding: '0.5rem',
    fontWeight: '600',
    fontSize: 'clamp(1.813rem, 0.808vw + 1.603rem, 2.25rem)',
    lineHeight: '1.2',
    color: '#6C2604',
  },
  '& fieldset': { borderColor: 'rgba(108,38,4,0.5) !important' },
});

export const CustomIcon = styled('img')(({ theme }) => ({
  height: '20px',
}));
